import React, { useState } from 'react';
import { WEB_API_ACCOUNT_NAV } from '../../../../assets/constants/strings';
import SettingsTitle from '../../UIElements/SettingsTitle';
import { connect } from 'react-redux';
import Loader from '../../../Loader';
import Card from './Card';
import CardModal from './CardModal';
import $ from 'jquery';
import {
  UpdateDefaultCard,
  DeleteCard,
} from '../../../../store/User/userActions';
import ConfirmationModal from '../../../Modals/Confirmation';

const mapStateToProps = (state) => ({
  user: state.user.user,
  cards: state.user.cards,
  loading: state.user.loading,
});

const mapDispatchToProps = { UpdateDefaultCard, DeleteCard };

const PaymentSettingsAPI = ({
  user,
  cards,
  loading,
  UpdateDefaultCard,
  DeleteCard,
}) => {
  const [editInfo, setEditInfo] = useState(null);

  const [showConfirm, setShowConfirm] = useState(false);

  const [confirmAction, setConfirmAction] = useState(null);

  const [modalText, setModalText] = useState('');

  const handleSelectedOption = (value, card) => {
    switch (value) {
      case 'default': {
        if (!card.isDefault) {
          setShowConfirm(true);
          setConfirmAction({ value: value, card: card });
          setModalText(
            'Are you sure you want to change you default card? This card will be used for all future subscriptions and invoices.'
          );
        }
        break;
      }
      case 'edit': {
        setEditInfo(card);
        $('#cardModal').modal('show');
        break;
      }
      case 'remove': {
        if (!(card.isDefault || cards.length === 1)) {
          setShowConfirm(true);
          setConfirmAction({ value: value, card: card });
          setModalText(
            'Are you sure you want to remove this card? This payment method will no longer be usable after removing.'
          );
        }
        break;
      }
      default:
        return;
    }
  };

  const handleDismiss = () => {
    setEditInfo(null);
  };

  const handleConfirm = () => {
    if (confirmAction.value === 'default')
      UpdateDefaultCard(confirmAction.card.id);
    else DeleteCard(confirmAction.card.id);
    dismissModal();
  };

  const dismissModal = () => {
    setShowConfirm(false);
    setModalText('');
    setConfirmAction(null);
  };

  const cardModalElement = document.getElementById('cardModal');

  return (
    <div id='payment-cards'>
      <SettingsTitle title={WEB_API_ACCOUNT_NAV.PAYMENT.TITLE} />

      {/* only show spinner if modal is not showing */}
      {/* {(!cards) &&
        (!cardModalElement || (
          cardModalElement && !cardModalElement.className.match('show')
        )) ? (
        <div className="inner-load">
          <Loader />
        </div>
      ) : ( */}
      <React.Fragment>
        {cards && cards.reason && cards.reason === 'Session Expired.' ? (
          <div className='card empty'>
            <div className='card-header'>
              <b>Session Expired. Please restart the app.</b>
            </div>
          </div>
        ) : cards && cards.length > 0 ? (
          cards.map((card, i) => (
            <Card
              key={i}
              index={i}
              card={card}
              isDefault={card.isDefault}
              handleOption={handleSelectedOption}
            />
          ))
        ) : (
          <div className='card empty'>
            <div className='card-header' style={{ display: 'inline' }}>
              No payment method saved yet. Click <b> Add </b> below to add a new
              payment method.
            </div>
          </div>
        )}
        <div className='card-buttons-row'>
          <button
            className='my-account-btn'
            onClick={() => $('#cardModal').modal('show')}
          >
            Add
          </button>
        </div>
        <CardModal
          handleDismiss={handleDismiss}
          isEdit={editInfo !== null}
          editInfo={editInfo}
        />
        <ConfirmationModal
          show={showConfirm}
          handleConfirm={handleConfirm}
          handleCancel={dismissModal}
          modalText={modalText}
        />
      </React.Fragment>
      {/* )} */}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSettingsAPI);
